import { render, staticRenderFns } from "./MultiChoiceQuestion.vue?vue&type=template&id=ffa2bd54"
import script from "./MultiChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./MultiChoiceQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultiChoiceQuestion.vue?vue&type=style&index=0&id=ffa2bd54&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports